/**
 * Checks if the current device is running iOS.
 *
 * @returns {boolean} True if the current device is an iPhone, iPad, or iPod; otherwise, false.
 */
export const isIOS = (): boolean => {
  return /iPhone|iPad|iPod/i.test(navigator.userAgent);
};
